// src/pages/ProfilePage.jsx
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import {
    Box,
    Typography,
    Button,
    Paper,
    Alert
} from '@mui/material';

export default function ProfilePage() {
    const { currentUser, logoutUser } = useAuth();

    const handleLogout = async () => {
        try {
            await logoutUser();
        } catch (err) {
            console.error('Logout error:', err);
        }
    };

    return (
        <Paper sx={{
            maxWidth: 600,
            mx: 'auto',
            mt: 4,
            p: 4,
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: '0 18px 40px rgba(15, 23, 42, 0.06)',
        }}>
            <Typography variant="h4" gutterBottom>
                Profile
            </Typography>

            <Box sx={{ mb: 3 }}>
                <Typography variant="body1">
                    <strong>Email:</strong> {currentUser?.email}
                </Typography>
                <Typography variant="body1">
                    <strong>Email Verified:</strong>
                    {currentUser?.emailVerified ? ' Yes' : ' No'}
                </Typography>
            </Box>

            {!currentUser?.emailVerified && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Your email is not verified. Please check your inbox.
                </Alert>
            )}

            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                    variant="contained"
                    component={Link}
                    to="/lesson"
                >
                    Browse courses
                </Button>
                <Button
                    variant="outlined"
                    color="error"
                    onClick={handleLogout}
                >
                    Log Out
                </Button>
            </Box>
        </Paper>
    );
}
